import { glob } from 'goober/global';

import type { CSS } from '~/styles';

export function addGlobalCss(css: Record<string, CSS>) {
  glob(css as Record<string, Record<string, string>>);
}
